import Map from '../components/map';

export default class ArchivesHeaderWithMap {
    constructor(element) {
        this.map = element
        this.gpx = this.map.getAttribute("data-gpx")
        this.locations = JSON.parse(this.map.getAttribute("data-locations"))
        this.startLocation = JSON.parse(this.map.getAttribute("data-start-location"))

        new Map(this.map, this.locations, this.gpx, this.startLocation)
    }
}